/**
 * App-wide configuration. The Supabase URL and publishable key are public by
 * design: they only grant what Row-Level Security allows. Override any value
 * with a `.env.local` file (see `.env.example`).
 */
export interface AppConfig {
  readonly appName: string;
  readonly supabaseUrl: string;
  readonly supabasePublishableKey: string;
  readonly apiBaseUrl: string;
  /** The single-file preview build never touches the network. */
  readonly demoOnly: boolean;
  /**
   * Whether the login screen offers "Create an account". Off by default so a
   * public URL can be browsed (and the demo explored) without strangers signing
   * up. The real lock is Supabase → Authentication → "Allow new users to sign up".
   */
  readonly allowSignup: boolean;
}

const DEFAULT_SUPABASE_URL = 'https://yarxeeujjzstzwbizgtx.supabase.co';
const DEFAULT_SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_f6pi0waYKYzBoSOLkJe_yQ_6gkYJRMP';
const DEFAULT_API_BASE_URL = 'https://diet-app-api.witt-development.workers.dev';

function clean(value: string | undefined, fallback: string): string {
  const v: string = (value ?? '').trim();
  return v.length > 0 ? v.replace(/\/+$/, '') : fallback;
}

export const config: AppConfig = {
  appName: 'Mighty Peanut Diet',
  supabaseUrl: clean(import.meta.env.VITE_SUPABASE_URL, DEFAULT_SUPABASE_URL),
  supabasePublishableKey: clean(import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY, DEFAULT_SUPABASE_PUBLISHABLE_KEY),
  apiBaseUrl: clean(import.meta.env.VITE_API_BASE_URL, DEFAULT_API_BASE_URL),
  demoOnly: __DEMO_ONLY__,
  allowSignup: (import.meta.env.VITE_ALLOW_SIGNUP ?? '').trim().toLowerCase() === 'true',
};
